module.exports = __webpack_public_path__ + "img/weixin.95e4e140.png";